import DevelopmentCycle from "./developmentcycle";

export default function Development({ toggleModal }) {
  return (
    <section className="relative block w-full lg:py-28 pt-[50px] pb-[100px]">
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="lg:grid grid-cols-1 relative lg:mb-0 mb-8">
          <div className="lg:pb-16 text-center">
            <h2
              className="lg:text-[50px] text-[35px] font-bold lg:leading-[65px] tracking-tight lg:mb-2 mb-5"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              Our Mobile App Development Process
            </h2>
            <p
              className="text-base font-normal leading-6 text-black mb-4"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              Glocify’s App Development Process Delivers Custom Solutions, Flawless Execution, 
              <br className="lg:block hidden" />
              and Unmatched Results.
            </p>
          </div>
        </div>
        <div className="relative border border-dashed border-[#B1B1B1] lg:rounded-[60px] rounded-[20px]">
          <DevelopmentCycle />
          <div className="text-center absolute left-0 right-0 mt-[-27px]">
            <button
              className="group relative flex h-[52px] mx-auto py-3 px-10 items-center justify-center gap-2 overflow-hidden bg-[#7C46EF] border border-solid border-[#7C46EF] rounded-[10px] text-white shadow-2xl text-base font-medium uppercase transition-all duration-700 ease-out before:absolute before:h-0 before:w-0 before:rounded-[10px] before:bg-[linear-gradient(269.02deg,#FF37EB_10.44%,#7c46ef_60%)] before:duration-700 before:ease-out hover:shadow-[#7c46ef]/20 hover:before:h-56 hover:before:w-full"
              onClick={toggleModal}
            >
              <span className="relative z-10 group-hover:text-white">
                Talk to an Expert
              </span>
              {/* <svg
                className="w-4 h-4 text-[#7C46EF] group-hover:text-white z-10"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg> */}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
